import {
  getDefaultRatingToMasteryLevelMapUrl,
  getMasteryLevelRatingsUrl,
  getMasteryLevelsUrl,
  updateAssociatedScalesByMapIdUrl,
} from "../config/Config";
import {
  deleteRequest,
  getRequest,
  postRequest,
  putRequest,
} from "./ServiceHelper";

export class MasteryLevelService {
  static getMasteryLevels = () => {
    return getRequest(getMasteryLevelsUrl());
  };

  static createOrUpdateMasteryLevels = (masteryLevels) => {
    const payLoad = { masteryLevels: masteryLevels };
    return postRequest(getMasteryLevelsUrl(), payLoad);
  };

  static getRatingToMasteryLevelMaps = () => {
    return getRequest(getMasteryLevelRatingsUrl()).then((maps) => {
      return maps.filter((map) => map.levels.length > 0);
    });
  };

  static getRatingToMasteryLevelMapsById = (mapId) => {
    return getRequest(getMasteryLevelRatingsUrl() + "/" + mapId);
  };

  static createOrUpdateRatingToMasteryLevelMap = (masteryLevelRatings) => {
    const payLoad = { masteryLevelRatings: masteryLevelRatings };
    return postRequest(getMasteryLevelRatingsUrl(), payLoad);
  };

  static deleteRatingToMasteryLevelMap = (ratingToMasteryLevelMapId) => {
    return deleteRequest(
      getMasteryLevelRatingsUrl() + "/" + ratingToMasteryLevelMapId
    );
  };

  static setDefaultRatingMap = (mapId) => {
    return putRequest(getDefaultRatingToMasteryLevelMapUrl(mapId));
  };

  static updateAssociatedScalesByMapId = (mapId) => {
    return putRequest(updateAssociatedScalesByMapIdUrl(mapId));
  };
}
